import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import SubmitButton from '../../../forms/formComponents/SubmitButton';

export function ConfirmAccessModal({
memberName,
onConfirm,
onCancel,
busy = false,
title = 'Access emergency contacts',
detailLabel = 'emergency contact information'
}) {
return ReactDOM.createPortal(
<div className="modal-backdrop">
<div className="modal-content" role="dialog" aria-modal="true" aria-label={`Confirm access to ${memberName}'s ${detailLabel}`}>
<h2 className="modal-title">{title}</h2>
<p>
You are about to access <strong>{memberName}</strong>'s {detailLabel}.
They will be notified you have done this. Do you wish to continue?
</p>
<div className="form-actions" style={{ display: 'flex', gap: 8, marginTop: 12 }}>
<SubmitButton type="button" variant="secondary" onClick={onCancel} label="Cancel" disabled={busy} />
<SubmitButton type="button" onClick={onConfirm} label={busy ? 'Please wait…' : 'Yes, continue'} disabled={busy} />
</div>
</div>
</div>,
document.body
);
}

ConfirmAccessModal.propTypes = {
memberName: PropTypes.string.isRequired,
onConfirm: PropTypes.func.isRequired,
onCancel: PropTypes.func.isRequired,
busy: PropTypes.bool,
title: PropTypes.string,
detailLabel: PropTypes.string,
};
